import React from 'react';
import { Zap, Settings, Target, Thermometer, Clock } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { services } from '../mockData';

const iconMap = {
  Zap: Zap,
  Settings: Settings,
  Target: Target
};

const Services = () => {
  return (
    <section id="services" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            {services.title}
          </h2>
          <p className="text-xl text-gray-600 leading-relaxed">
            {services.description}
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {services.features.map((feature, index) => {
            const Icon = iconMap[feature.icon];
            return (
              <Card key={index} className="border-2 hover:border-green-600 transition-all duration-300 hover:shadow-xl">
                <CardHeader>
                  <div className="w-14 h-14 bg-gradient-to-br from-green-600 to-blue-600 rounded-xl flex items-center justify-center mb-4">
                    <Icon className="w-7 h-7 text-white" />
                  </div>
                  <CardTitle className="text-xl">{feature.title}</CardTitle>
                  <CardDescription className="text-base">
                    {feature.description}
                  </CardDescription>
                </CardHeader>
              </Card>
            );
          })}
        </div>

        {/* Specifications Section */}
        <div className="relative">
          {/* Background Image */}
          <div className="absolute inset-0 rounded-3xl overflow-hidden">
            <img
              src="https://images.unsplash.com/photo-1646956141271-05281b4ef472"
              alt="Laboratory"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-blue-900/95 via-blue-900/90 to-green-900/85"></div>
          </div>

          {/* Content */}
          <div className="relative z-10 py-16 px-8">
            <div className="max-w-5xl mx-auto">
              <h3 className="text-3xl font-bold text-white mb-12 text-center">
                Custom Synthesis Specifications
              </h3>

              <div className="grid md:grid-cols-2 gap-8">
                {/* Temperature Card */}
                <Card className="bg-white/10 backdrop-blur-md border-white/20 hover:bg-white/15 transition-all duration-300">
                  <CardHeader>
                    <div className="flex items-center space-x-4 mb-4">
                      <div className="w-12 h-12 bg-orange-500 rounded-lg flex items-center justify-center">
                        <Thermometer className="w-6 h-6 text-white" />
                      </div>
                      <div>
                        <CardTitle className="text-white text-2xl">
                          {services.specifications.temperature.label}
                        </CardTitle>
                        <div className="text-orange-300 text-lg font-semibold">
                          {services.specifications.temperature.range}
                        </div>
                      </div>
                    </div>
                    <CardDescription className="text-gray-200 text-base">
                      {services.specifications.temperature.description}
                    </CardDescription>
                  </CardHeader>
                </Card>

                {/* Duration Card */}
                <Card className="bg-white/10 backdrop-blur-md border-white/20 hover:bg-white/15 transition-all duration-300">
                  <CardHeader>
                    <div className="flex items-center space-x-4 mb-4">
                      <div className="w-12 h-12 bg-green-500 rounded-lg flex items-center justify-center">
                        <Clock className="w-6 h-6 text-white" />
                      </div>
                      <div>
                        <CardTitle className="text-white text-2xl">
                          {services.specifications.duration.label}
                        </CardTitle>
                        <div className="text-green-300 text-lg font-semibold">
                          {services.specifications.duration.range}
                        </div>
                      </div>
                    </div>
                    <CardDescription className="text-gray-200 text-base">
                      {services.specifications.duration.description}
                    </CardDescription>
                  </CardHeader>
                </Card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
